module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lgLpa"))).then(() => parcelRequire('d0iPb'));